import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Activity, Edit2, Filter, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {HiOutlineViewList} from "react-icons/hi";
import AddUserModalForm from "./modals/AddUserModal";
import DeleteMerchantPlaceModal from "./modals/DeleteMerchantPlaceModal";
import AddRewardModal from "./modals/AddRewardModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import AddNotificationModal from "./modals/AddNotificationModal";
import AddMerchantPlacesModal from "./modals/AddMerchantPlacesModal";
import Moment from "moment";

function getMerchantPlaces() {

    return fetch('https://back-api.therunningcollective.fr/merchant-places', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(merchantPlace, checked) {
    merchantPlace.enable = checked
    return fetch('https://back-api.therunningcollective.fr/merchant-place', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(merchantPlace)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class MerchantPlacesList extends Component {
    state = {
        errors: null,
        selectedMerchantPlace: {
            name: "",
            description: "",
            logo: "",
            cover: "",
            redirectLink: ""
        },
    }

    async componentDidMount() {
        await getMerchantPlaces().then(data => {
            this.setState({merchantPlaces: data})
        }).catch(err =>
            this.setState({errors: "error while getting merchantPlaces"})
        );
    };

    closeModal = () => this.setState({
        isOpen: false,
        isDelete: false,
        isDrawing: false,
        selectedMerchantPlace: {
            title: "",
            body: "",
        }
    });


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={11} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter une offre</Button>
                    </Col>
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={11} className="products-buttons">
                        {(this.state.merchantPlaces && this.state.merchantPlaces.length > 0 && this.state.errors == null) ? <span>{this.state.merchantPlaces.length} offres Corner TRC</span> : null }
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des offers Corner, veuillez vous reconnecter"</p> : null}

                { (!this.state.merchantPlaces && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th></th>
                            <th>Nom</th>
                            <th>Description</th>
                            <th>Date de début</th>
                            <th>Date de fin</th>
                            <th>Vente privée</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.merchantPlaces.map(merchantPlace => (
                            <tr>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Afficher l'offre' sur le site</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={merchantPlace.enable}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateState(merchantPlace, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{merchantPlace.name}</td>
                                <td>{merchantPlace.description}</td>
                                <td>{Moment(merchantPlace.beginDate).format('YYYY-MM-DDTHH:mm').toString()}</td>
                                <td>{Moment(merchantPlace.endDate).format('YYYY-MM-DDTHH:mm').toString()}</td>
                                <td>{merchantPlace.isPrivateSale ? "Oui" : "Non"}</td>
                                <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={merchantPlace.cover}/>
                                </td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Modifier l'offre</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Edit2 className="align-middle mr-1" size={18}
                                               onClick={(e) => this.setState({isOpen: true, selectedMerchantPlace: merchantPlace})}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Supprimer l'offre</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Trash className="align-middle" size={18}
                                               onClick={(e) => this.setState({isDelete: true, selectedMerchantPlace: merchantPlace})}/>
                                    </td>
                                </OverlayTrigger>

                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddMerchantPlacesModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedMerchantPlace={this.state.selectedMerchantPlace}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteMerchantPlaceModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedMerchantPlace}
                        selectedCategory="merchant-places"
                    />
                    :
                    null
                }
            </div>
        );

    }
}